<template>
  <div
    :class="`colored-status ${withBorder ? 'colored-status--border' : ''} ${isChecked ? 'colored-status--checked' : ''}`"
    :style="style">
    <span
      v-if="markerColor"
      class="colored-status__marker"
      :style="`background-color: ${markerColor}`"
    ></span>
    <i v-if="icon" :class="`fa-regular ${icon}`"></i>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: ['markerColor', 'withBorder', 'isChecked', 'icon', 'style']
}
</script>

<style lang="scss" scoped>
.colored-status {
  display: inline-block;
  color: var(--attendee-text-primary-color);
  font-size: 15px;
  border-radius: 4px;
  font-weight: 600;
  line-height: 19px;
  margin: 0;
  padding: 0;
  text-transform: inherit;


  i, svg{
    color: inherit;
    margin-right: 3px;
  }

  &__marker {
    line-height: 19px;
    display: inline-block;
    margin-right: 3px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }

  &--checked {
    background-color: rgba(27, 217, 210, 0.1);

    &.colored-status--border {
      border: 1px solid rgba(27, 217, 210, 0.3);
    }
  }

  &--border {
    border: 1px solid var(--attendee-border-color);
    padding: 3px 10px;
  }
}
</style>